import { Badge } from '../../../shared/ui';
import type { AttributionType } from './AttributionNotice';

export interface AttributionBadgeProps {
  type: AttributionType;
  /** Resolved server-side, already localised and admin-editable per type. */
  label: string;
  className?: string;
}

/**
 * The compact form of the same disclosure `AttributionNotice` makes in full —
 * a card on a listing page carries this instead of the notice itself.
 *
 * Visible text, always. Not a tooltip triggered by hover or focus alone, and
 * not a link: badges here are labels, not affordances, so a screen-reader
 * user and a sighted skimmer get the same information from the same render.
 */
export function AttributionBadge({ type, label, className }: AttributionBadgeProps) {
  return (
    <Badge tone={type === 'in_house' ? 'neutral' : 'info'} {...(className ? { className } : {})}>
      {label}
    </Badge>
  );
}
